import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCycleDuration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 93.744,
	height: 33.802,
	viewBox: "0 0 93.744 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_103",
		"data-name": "Group 103",
		transform: "translate(0)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_100",
				"data-name": "Group 100",
				transform: "translate(0 0)",
				opacity: 0,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_241",
					"data-name": "Path 241",
					d: "M291.773,82.461H198.029v-33.8h93.744Zm-93.067-.52H291.1V49.179H198.706Z",
					transform: "translate(-198.029 -48.659)",
					fill: "#040505"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_101",
				"data-name": "Group 101",
				transform: "translate(8.009 15.22)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_242",
					"data-name": "Path 242",
					d: "M213.439,77.944",
					transform: "translate(-213.439 -77.944)",
					fill: "none",
					stroke: "#040505",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_243",
				"data-name": "Path 243",
				d: "M228.049,60.521a2.245,2.245,0,0,0-2.5.246c-.3.24-.646.521-1.011.821a22.581,22.581,0,0,1-4.3,3.062c-1.512.51-5.865,1.4-7.666,1.757a1.235,1.235,0,0,0-.638.349c-.189-.155-.384-.324-.586-.525-1.307-1.3-4.5-4.542-4.5-4.543l-1.481,1.459s3.208,3.255,4.519,4.558a9.3,9.3,0,0,0,2.5,1.815c.02.028.037.054.058.083a3.307,3.307,0,0,1-1.222,1.592,4.252,4.252,0,0,1-1.672.481h0c-.046,0-.088.021-.133.028-.217-.31-.5-.694-.879-1.194a30.058,30.058,0,0,0-4.963-4.386,1.04,1.04,0,0,0-1.213,1.689,27.611,27.611,0,0,1,4.512,3.943c.489.652.762,1.036.914,1.257a2.1,2.1,0,0,0-.068,1.333,10.279,10.279,0,0,0,.723,1.815,18.813,18.813,0,0,0,1.9,3.052,6.191,6.191,0,0,0,.792,2.192,1.041,1.041,0,0,0,.78.584,3.149,3.149,0,0,0,.47.03,6.972,6.972,0,0,0,4.432-1.833c2.234-1.875,8.8-8.628,9.108-8.948.135-.151,3.3-3.745,3.617-6.924C229.718,62.545,229.159,61.126,228.049,60.521Zm-.575,3.59c-.206,2.08-2.309,4.855-3.07,5.714-.068.07-6.77,6.964-8.923,8.771a5.376,5.376,0,0,1-2.736,1.323c-.142-.327-.259-.619-.309-.774l.016-.154a1.045,1.045,0,0,0-.253-.789,15.621,15.621,0,0,1-1.9-2.972,7.277,7.277,0,0,1-.573-1.468c.009-.012.016-.014.019-.014a6.155,6.155,0,0,0,2.515-.75,5.68,5.68,0,0,0,2.353-3.332,1.042,1.042,0,0,0-.2-.9c-.134-.168-.269-.354-.389-.533,2.324-.472,5.522-1.159,6.872-1.614,1.216-.41,2.89-1.735,4.951-3.424.358-.293.692-.567.987-.8.122-.1.18-.065.213-.047C227.281,62.47,227.58,63.042,227.473,64.111Z",
				transform: "translate(-199.903 -54.226)",
				fill: "#040505",
				opacity: .3
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_244",
				"data-name": "Path 244",
				d: "M301.783,60.521a2.243,2.243,0,0,0-2.5.246c-.3.24-.644.521-1.01.82a22.586,22.586,0,0,1-4.3,3.063c-1.512.51-5.865,1.4-7.666,1.757a1.238,1.238,0,0,0-.638.349c-.189-.155-.383-.324-.586-.525-1.307-1.3-4.5-4.542-4.5-4.543L279.1,63.148s3.208,3.255,4.519,4.558a9.32,9.32,0,0,0,2.505,1.816c.02.028.037.054.057.082a3.308,3.308,0,0,1-1.222,1.592,4.25,4.25,0,0,1-1.672.481h0c-.046,0-.088.02-.133.028-.217-.31-.5-.693-.879-1.194a30.061,30.061,0,0,0-4.962-4.386,1.04,1.04,0,0,0-1.213,1.689,27.636,27.636,0,0,1,4.512,3.943c.489.652.762,1.036.914,1.257a2.1,2.1,0,0,0-.069,1.333,10.317,10.317,0,0,0,.723,1.815,18.819,18.819,0,0,0,1.9,3.052,6.2,6.2,0,0,0,.792,2.192,1.04,1.04,0,0,0,.78.584,3.132,3.132,0,0,0,.469.03,6.97,6.97,0,0,0,4.432-1.832c2.234-1.875,8.8-8.628,9.109-8.948.135-.151,3.3-3.745,3.617-6.925C303.452,62.544,302.893,61.126,301.783,60.521Zm-.575,3.59c-.206,2.08-2.309,4.855-3.07,5.714-.068.07-6.77,6.964-8.923,8.771a5.374,5.374,0,0,1-2.736,1.323c-.142-.327-.259-.619-.309-.774l.016-.154a1.046,1.046,0,0,0-.253-.79,15.5,15.5,0,0,1-1.9-2.972,7.236,7.236,0,0,1-.573-1.468c.008-.012.015-.014.018-.014A6.152,6.152,0,0,0,286,73a5.681,5.681,0,0,0,2.353-3.332,1.041,1.041,0,0,0-.2-.9c-.132-.165-.267-.352-.388-.532,2.324-.472,5.522-1.159,6.872-1.614,1.216-.41,2.89-1.735,4.952-3.425.357-.293.692-.566.986-.8.123-.1.179-.065.213-.047C301.015,62.469,301.314,63.042,301.208,64.11Z",
				transform: "translate(-235.317 -54.225)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_245",
				"data-name": "Path 245",
				d: "M262.28,97.017c.013-.032.021-.066.031-.1s.021-.062.028-.095a1.019,1.019,0,0,0,.02-.2V96.62h0a1.032,1.032,0,0,0-.02-.2c-.006-.029-.017-.056-.025-.083a.955.955,0,0,0-.034-.111c-.013-.032-.032-.061-.048-.091s-.029-.06-.048-.088a1.074,1.074,0,0,0-.119-.146s-.006-.008-.01-.012l-2.768-2.768a1.039,1.039,0,0,0-1.47,1.47l.994.994H236a1.039,1.039,0,0,0,0,2.079h22.81l-.993.993a1.039,1.039,0,1,0,1.47,1.47l2.766-2.765a1.034,1.034,0,0,0,.132-.161c.015-.023.025-.047.038-.071A1.021,1.021,0,0,0,262.28,97.017Z",
				transform: "translate(-215.767 -69.865)",
				fill: "#040505"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_102",
				"data-name": "Group 102",
				transform: "translate(69.126 8.116)",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Path_246",
					"data-name": "Path 246",
					d: "M346.025,68.2V66.468a2.194,2.194,0,0,0-2.191-2.192h-2.839a2.194,2.194,0,0,0-2.191,2.192v1.724a8.731,8.731,0,0,0-1.342.75,1.04,1.04,0,0,0,1.176,1.715,6.693,6.693,0,1,1-2.822,6.578l1.063,1.063a1.039,1.039,0,1,0,1.47-1.47l-2.768-2.768a1.039,1.039,0,0,0-1.47,0l-2.768,2.768a1.039,1.039,0,1,0,1.47,1.47l.924-.924A8.764,8.764,0,1,0,346.025,68.2Zm-5.142-.648V66.468a.113.113,0,0,1,.112-.113h2.839a.113.113,0,0,1,.112.113v1.085a8.413,8.413,0,0,0-3.063,0Z",
					transform: "translate(-331.038 -64.276)",
					fill: "#040505"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_247",
					"data-name": "Path 247",
					d: "M351.966,76.259a1.039,1.039,0,0,0-1.039,1.039v4.636a1.04,1.04,0,0,0,.3.735l2.5,2.5a1.039,1.039,0,0,0,1.47-1.47L353.006,81.5V77.3A1.039,1.039,0,0,0,351.966,76.259Z",
					transform: "translate(-340.591 -70.031)",
					fill: "#040505"
				})]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgCycleDuration);
export { ForwardRef as ReactComponent };
